import React, { useEffect, useState } from "react"
import { Card, Button } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import Layout from "../../../layout/default"
import Block from "../../../components/Block/Block"
import DataTable from "../../../components/DataTable/DataTable"
import { Icon } from "../../../components"
import planService from "../services/planService"

const PlanList = () => {
  const navigate = useNavigate()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    let mounted = true
    ;(async () => {
      setLoading(true)
      setError(null)
      try {
        const response = await planService.list()
        let data = []
        if (Array.isArray(response)) {
          data = response
        } else if (Array.isArray(response.results)) {
          data = response.results
        } else if (Array.isArray(response.data)) {
          data = response.data
        } else {
          console.warn('Unexpected response format:', response)
        }
        if (mounted) setRows(data)
      } catch (err) {
        console.error('Error fetching plans', err)
        if (mounted) setError('No se pudo cargar los planes.')
      } finally {
        if (mounted) setLoading(false)
      }
    })()
    return () => { mounted = false }
  }, [])

  const handleDelete = async (id) => {
    if (!window.confirm("¿Eliminar plan?")) return
    setLoading(true)
    try {
      await planService.remove(id)
      setRows(prev => prev.filter(r => r.id !== id))
    } catch (err) {
      console.error('Error deleting plan', err)
      setError('No se pudo eliminar el plan.')
    } finally {
      setLoading(false)
    }
  }

  const columns = [
    { name: "ID", selector: r => r.id, sortable: true },
    { name: "Código", selector: r => r.code, sortable: true },
    { name: "Nombre", selector: r => r.name, sortable: true },
    { name: "Precio €/mes", selector: r => r.base_price, sortable: true },
    { name: "Activo", selector: r => (r.active ? "Sí" : "No"), sortable: true },
    {
      name: "Acciones",
      cell: row => (
        <>
          <Button
            size="sm"
            variant="outline-primary"
            className="me-1"
            onClick={() => navigate(`/plan/edit/${row.id}`)}
          >
            <Icon name="edit" />
          </Button>
          <Button
            size="sm"
            variant="outline-danger"
            onClick={() => handleDelete(row.id)}
          >
            <Icon name="trash" />
          </Button>
        </>
      ),
    },
  ]

  return (
    <Layout title="Planes" content="container" loading={loading}>
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Planes</Block.Title>
          </Block.HeadContent>
          <Block.HeadContent>
            <Button variant="primary" onClick={() => navigate("/plan/new") }>
              <Icon name="plus" />
              <span> Nuevo plan</span>
            </Button>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card body>
          {error && <div className="mb-3 text-danger">{error}</div>}
          <DataTable
            data={rows}
            columns={columns}
            progressPending={loading}
            noDataComponent={<div>No hay registros.</div>}
            pagination
            highlightOnHover
            searchByList={["code", "name"]}
            className="data-table-head-light"
          />
        </Card>
      </Block>
    </Layout>
  )
}

export default PlanList
